import React from 'react';
import { ButtonGroup, ClickAwayListener, Grow, Paper, Popper, MenuItem, MenuList, withStyles } from '@material-ui/core';
import CustomButton from '../Button/Button';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import clsx from 'clsx';

const styles = theme => ({
    popover: {
        zIndex: 1,
    },
    menuItem: {
        '& svg': {
            maxWidth: '20px',
            marginRight: '6px'
        },
        '&.primary': {
            '& svg': {
                '& path': {
                    'fill': theme.buttons.primary.default.svg
                }
            },
            '&:hover': {
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.primary.hover.svg
                    }
                },
            },
            '&:active': {
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.primary.active.svg
                    }
                },
            },
            '&:disabled': {
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.primary.disabled.svg
                    }
                },
            },

        },
        '&.secondary': {
            '& svg': {
                '& path': {
                    'fill': theme.buttons.secondary.default.svg
                }
            },
            '&:hover': {
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.secondary.hover.svg
                    }
                },
            },
            '&:active': {
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.secondary.active.svg
                    }
                },
            },
            '&:disabled': {
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.secondary.disabled.svg
                    }
                },
            }
        },
        '&.tertiary': {
            '& svg': {
                '& path': {
                    'fill': theme.buttons.tertiary.default.svg
                }
            },
            '&:hover': {
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.tertiary.hover.svg
                    }
                },
            },
            '&:active': {
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.tertiary.active.svg
                    }
                },
            },
            '&:disabled': {
                '& svg': {
                    '& path': {
                        'fill': theme.buttons.tertiary.disabled.svg
                    }
                },
            }
        }
    },
})

const SplitButton = (props) => {
    let { options, open = false, selectedIndex = 0, size, color, handleClick, handleMenuItemClick, handleToggle, handleClose, classes, className, disabled } = props;
    const anchorRef = React.useRef(null);
    return (
        <React.Fragment>
            <ButtonGroup variant="outlined" color="secondary" ref={anchorRef} aria-label="split button" className={clsx(className, size, color)} disabled={disabled}>
                <CustomButton
                    onClick={handleClick}
                    variant="outlined"
                    size='medium'
                    color='secondary'
                >
                    {options[selectedIndex].icon ? <FontAwesomeIcon icon={['fas', options[selectedIndex].icon]} /> : ''}
                    {options[selectedIndex].label}
                </CustomButton>
                <CustomButton
                    onClick={handleToggle}
                    variant="outlined"
                    size='medium'
                    color='secondary'
                >
                    <FontAwesomeIcon icon={['fas', 'chevron-down']} />
                </CustomButton>
            </ButtonGroup>
            <Popper
                open={open}
                anchorEl={anchorRef.current}
                placement={'bottom-end'}
                transition
                className={classes.popover}
            >
                {({ TransitionProps, placement }) => (
                    <Grow
                        {...TransitionProps}
                        style={{
                            transformOrigin: placement === 'bottom' ? 'center top' : 'right bottom',
                        }}
                    >
                        <Paper>
                            <ClickAwayListener onClickAway={handleClose}>
                                <MenuList>
                                    {options.map((option, index) => (
                                        <MenuItem
                                            key={option.value}
                                            className={clsx(classes.menuItem, color)} 
                                            selected={index === selectedIndex}
                                            onClick={event => handleMenuItemClick(event, index)}
                                        >
                                            {option.icon ? <FontAwesomeIcon icon={['fas', option.icon]} /> : ''}
                                            {option.label}
                                        </MenuItem>
                                    ))}
                                </MenuList>
                            </ClickAwayListener>
                        </Paper>
                    </Grow>
                )}
            </Popper>
        </React.Fragment>
    );
}

export default withStyles(styles)(SplitButton)